import { useLanguage } from "../context/LanguageContext";

export default function AsyncState({ loading, error, onRetry, children }) {
  const { t } = useLanguage();
  if (loading) return <div className="async-state" role="status"><span className="spinner" />{t("loading")}</div>;
  if (error) {
    return (
      <div className="async-state" role="alert">
        <p>{error}</p>
        {onRetry && <button className="button-secondary" onClick={onRetry}>{t("retry")}</button>}
      </div>
    );
  }
  return children;
}
